import memoize from 'fast-memoize';
import { format } from 'date-fns';

const formatTime = memoize(date => format(date, 'hh:mm aa'));

export default formatTime;
